import React, { Component } from 'react';
import Loading from '../../Loading';
import AcompanhamentoShared from '../../shared/acompanhamento/Acompanhamento';

import * as AcompanhamentoRequest from '../../../requests/acompanhamento.request';
import * as SimuladoRequest from '../../../requests/simulado.request';


class Acompanhamento extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loadingGeral: false,
            mediaComponenteCurricular: 0,
            mediaTRI: 0,
            mediaTRIEscola: 0,
            notasTRI: [],
            mediasDisciplina: [],
            mediashabilidade: [],
            simuladoAtual: ''
        }

    }

    async componentDidMount() {

        //Exibindo o loading
        this.setState({ loadingGeral: true });

        // Atualiza situacao do simulado
        await SimuladoRequest.setSituacaoSimulado();

        //Buscando as médias por disciplina
        var mediasDisciplina = await AcompanhamentoRequest.getMediasDisciplina();
        console.log(mediasDisciplina)

        //Buscando as médias por habilidade
        var mediasHabilidade = await AcompanhamentoRequest.getMediasHabilidade();
        console.log(mediasHabilidade)

        var notasTRI = this.props.notasTRI

        //Se não tem informação, exibe o emptyState
        if (!notasTRI || notasTRI.length === 0 || !mediasDisciplina || mediasDisciplina.length === 0 || !mediasHabilidade || mediasHabilidade.length === 0) {
            this.setState({ loadingGeral: false });
            return;
        }
        //Define os estados das médias
        this.setState({ notasTRI: notasTRI, mediaTRI: this.props.mediaTRI, mediaTRIEscola: this.getMediaTRIEscola(notasTRI), mediasDisciplina: mediasDisciplina, mediaComponenteCurricular: this.getMediaDisciplina(mediasDisciplina), mediasHabilidade: mediasHabilidade, simuladoAtual: this.props.simuladoAtual });

        //Esconde o loading
        this.setState({ loadingGeral: false });
    }

    getMediaTRIEscola(medias) {
        return (medias.reduce((partial_sum, a) => (partial_sum + a.nuScoreTRISchool), 0) / medias.length).toFixed(2);
    }

    getMediaDisciplina(medias) {
        return Math.trunc(medias.reduce((total, soma, index, array) => {
            total += soma.pcCorrectStudent;
            if (index === array.length - 1) {
                return total / array.length;
            } else {
                return total;
            }
        }, 0));
    }

    render() {
        return (
            <div className="edb-padding-top">

                {this.state.loadingGeral && <Loading />}

                {!this.state.loadingGeral &&
                    <AcompanhamentoShared
                        mediaTRI={this.state.mediaTRI}
                        mediaTRIEscola={this.state.mediaTRIEscola}
                        notasTRI={this.state.notasTRI}
                        mediasDisciplina={this.state.mediasDisciplina}
                        mediaComponenteCurricular={this.state.mediaComponenteCurricular}
                        mediasHabilidade={this.state.mediasHabilidade}
                        simuladoAtual={this.state.simuladoAtual}
                    />}
            </div>
        );
    }
}

export default Acompanhamento;